import { createReducer, on } from '@ngrx/store';
import {
  SPECIAL_PRICE_FIND_SUCCESS,
  SPECIAL_PRICE_FAILURE,
  SPECIAL_PRICE_RESET_ERROR,
  SPECIAL_PRICE_RESET,
  SPECIAL_PRICE_FIND_ALL_SUCCESS,
  SPECIAL_PRICE_CLEAR_STATE,
  SPECIAL_PRICE_UPDATE_LOADING,
} from '@store/actions';
import { IResponseBadRequest } from '@core/interfaces';
import {
  SpecialPrice,
} from '@core/models';

export interface SpecialPriceState {
  loading: boolean;
  specialPrice: SpecialPrice | null;
  specialPriceList: SpecialPrice[] | null;
  error: IResponseBadRequest | null;
}

export const initialState: SpecialPriceState = {
  loading: false,
  specialPrice: null,
  specialPriceList: null,
  error: null,
};

export const specialPriceReducer = createReducer(
  initialState,
  on(SPECIAL_PRICE_FIND_SUCCESS, (state, { specialPrice }) => ({ ...state, specialPrice })),
  on(SPECIAL_PRICE_FIND_ALL_SUCCESS, (state, { specialPriceList }) => ({ ...state, specialPriceList })),
  on(SPECIAL_PRICE_FAILURE, (state, { error }) => ({ ...state, error })),
  on(SPECIAL_PRICE_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(SPECIAL_PRICE_RESET, (state) => ({ ...state, specialPrice: null, specialPriceId: null, specialPriceForm: null })),
  on(SPECIAL_PRICE_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(SPECIAL_PRICE_CLEAR_STATE, () => initialState),
);
